import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { createTutorSchedule } from "../../api/endpoints/tutors/schedules";
import ContainerMd from "../../components/Layouts/ContainerMd";
import FreeTimeSchedule from "../tutor/FreeTimeSchedule";
import toast from "react-hot-toast";
import { FREE_TIME_STEP_INDEX, TUTOR_STEPS } from "./completeAccountUtils";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";

export default function CreateFreeTimeSchedule() {
  const LocalBasePath = "toast";
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const authContext = useAuth();

  const saveSchedule = async (data: any) => {
    const response = await createTutorSchedule(data);
    if (response.isSuccess) {
      toast.success(t("toast.scheduleCreatedSuccessfully"));
      await authContext?.fetchCurrentUser();
      navigate(`/`);
    } else {
      response.errorMessages.forEach((error: any) => {
        toast.error(error);
      });
    }
  };

  let submitButtonText = t(`page.freeTime.save`);

  let stepInfo = `${FREE_TIME_STEP_INDEX + 1} ${t("page.steps.of")} ${
    TUTOR_STEPS.length
  }`;
  let previousButtonText = `${t("page.steps.previous")}: ${t(
    TUTOR_STEPS[FREE_TIME_STEP_INDEX - 1].name
  )}`;

  return (
    <ContainerMd className={"flex-1 flex flex-col"}>
      <FreeTimeSchedule
        showLogo={true}
        onSaveSlots={saveSchedule}
        prevPage={() => navigate(TUTOR_STEPS[FREE_TIME_STEP_INDEX - 1].route)}
        submitButtonText={submitButtonText}
        previousButtonText={previousButtonText}
        stepInfo={stepInfo}
        showHeader={true}
        showChangeLanguage={true}
      />
    </ContainerMd>
  );
}
